<template>
	<div class="coll">
		<h2 class="title"><span>{{title}}</span></h2>
		<div class="cons" style="margin-top:20px;width:20%">
			销售订单号：{{sdata.details[0].materailVoucherNo}}
		</div>
	</div>
</template>

<script>
export default{
	components:{
		
	},
	props:{
		title:String,
		sdata:Object
	},
	created(){

	},
	methods:{
		
	}
}
</script>

<style>
</style>
